// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"43d79275","703":"76d8d852","787":"cb433faf"}[chunkId] + ".chunk.js";
};